module.exports = __webpack_public_path__ + "static/img/kh-6.2526420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-6.png
// module id = zFPc
// module chunks = 4